<script>
import api from '@/api'
import { alertSuccess } from '@/helpers/swal'

export default {
  data() {
    return {
      pagetitle: 'Credentials',
      credential: {
        protocolType: 'collectd',
        snmpVersion: 'v1v2',
        profileName: '',
        readCommunity: '',
        writeCommunity: '',
        description: '',
        username: '',
        password: '',
        contextName: '',
        authMethod: 'MD5',
        authPassword: '',
        encryptionMethod: 'DES',
        encryptionPassword: '',
        snmpPort: 161,
        timeout: 5,
        retries: 0,
      },
      errors: {
        profileName: '',
        readCommunity: '',
        writeCommunity: '',
        description: '',
        username: '',
        password: '',
        contextName: '',
        authMethod: '',
        authPassword: '',
        encryptionMethod: '',
        encryptionPassword: '',
        snmpPort: '',
        timeout: '',
        retries: '',
      },
      saveBtnDisabled: false,
    }
  },
  components: {},
  mounted() {
    // In case of edit credential
    const credentialId = this.$route.params.id
    if (credentialId) {
      this.getCredentialData(credentialId)
    }
  },
  methods: {
    getCredentialData(credentialId) {
      api.get(`/credentials/${credentialId}`).then((response) => {
        this.credential = response.data
      })
    },

    saveCredential() {
      if (!this.validateRequest()) return

      this.saveBtnDisabled = true
      let {
        id,
        protocolType,
        profileName,
        username,
        password,
        snmpVersion,
        description,
        snmpPort,
        timeout,
        retries,
        readCommunity,
        writeCommunity,
        contextName,
        authMethod,
        authPassword,
        encryptionMethod,
        encryptionPassword,
      } = this.credential

      let data = {}

      if (id) data.id = id
      data.protocolType = protocolType
      data.profileName = profileName

      if (protocolType === 'collectd') {
        data.username = username
        data.password = password
      } else if (protocolType === 'snmp') {
        data.snmpVersion = snmpVersion
        data.description = description
        data.snmpPort = snmpPort
        data.timeout = timeout
        data.retries = retries

        if (snmpVersion === 'v1v2') {
          data.readCommunity = readCommunity
          data.writeCommunity = writeCommunity
        } else if (snmpVersion === 'v3') {
          data.username = username
          data.contextName = contextName
          data.authMethod = authMethod
          data.authPassword = authPassword
          data.encryptionMethod = encryptionMethod
          data.encryptionPassword = encryptionPassword
          data.password = password
        }
      }

      const params = new URLSearchParams(data)
      this.credential.id ? this.updateCredential(params) : this.addCredential(params)
    },

    addCredential(data) {
      api
        .post('/credentials/add', data)
        .then(() => {
          alertSuccess('Credential added successfully')
          this.$router.push({ name: 'credentials' })
        })
        .finally(() => {
          this.saveBtnDisabled = false
        })
    },

    updateCredential(data) {
      api
        .post(`/credentials/modify/${this.credential.id}`, data)
        .then(() => {
          alertSuccess('Credential updated successfully')
          this.$router.push({ name: 'credentials' })
        })
        .finally(() => {
          this.saveBtnDisabled = false
        })
    },

    validateRequest() {
      let isValid = true
      this.errors = {}

      const { protocolType, profileName, username, password, snmpVersion, snmpPort, timeout, retries, authMethod, authPassword, encryptionMethod, encryptionPassword } = this.credential

      if (!profileName) {
        this.errors.profileName = 'Profile name is required'
        isValid = false
      }

      if (protocolType === 'collectd') {
        if (!username) {
          this.errors.username = 'Username is required'
          isValid = false
        }
        if (!password) {
          this.errors.password = 'Password is required'
          isValid = false
        } else {
          isValid = this.validatePassword(password)
        }
      } else if (protocolType === 'snmp') {
        if (!snmpVersion) {
          this.errors.snmpVersion = 'SNMP version is required'
          isValid = false
        }
        if (!snmpPort) {
          this.errors.snmpPort = 'SNMP port is required'
          isValid = false
        }
        if (!timeout) {
          this.errors.timeout = 'Timeout is required'
          isValid = false
        }
        if (retries === '') {
          this.errors.retries = 'Retries is required'
          isValid = false
        }
        if (snmpVersion === 'v3') {
          if (!username) {
            this.errors.username = 'Username is required'
            isValid = false
          }
          if (!password) {
            this.errors.password = 'Password is required'
            isValid = false
          } else {
            isValid = this.validatePassword(password)
          }
          if (!authMethod) {
            this.errors.authMethod = 'Auth method is required'
            isValid = false
          }
          if (!authPassword) {
            this.errors.authPassword = 'Auth password is required'
            isValid = false
          } else {
            isValid = this.validateAuthPassword(authPassword)
          }
          if (!encryptionMethod) {
            this.errors.encryptionMethod = 'Encryption method is required'
            isValid = false
          }
          if (!encryptionPassword) {
            this.errors.encryptionPassword = 'Encryption password is required'
            isValid = false
          } else {
            isValid = this.validateEncryptionPassword(encryptionPassword)
          }
        }
      }
      return isValid
    },
    validatePassword(password) {
      let isValid = true
      if (password.length < 6) {
        this.errors.password = 'Password must be at least 6 characters.'
        isValid = false
      } else if (!/[A-Z]/.test(password)) {
        this.errors.password = 'Password must contain at least one uppercase letter.'
        isValid = false
      } else if (!/[a-z]/.test(password)) {
        this.errors.password = 'Password must contain at least one lowercase letter.'
        isValid = false
      } else if (!/[0-9]/.test(password)) {
        this.errors.password = 'Password must contain at least one digit.'
        isValid = false
      } else if (!/[!@#$%^&*(),.?":{}|<>]/.test(password)) {
        this.errors.password = 'Password must contain at least one special character.'
        isValid = false
      }
      return isValid
    },
    validateAuthPassword(password) {
      let isValid = true
      if (password.length < 6) {
        this.errors.authPassword = 'Auth Password must be at least 6 characters.'
        isValid = false
      } else if (!/[A-Z]/.test(password)) {
        this.errors.authPassword = 'Auth Password must contain at least one uppercase letter.'
        isValid = false
      } else if (!/[a-z]/.test(password)) {
        this.errors.authPassword = 'Auth Password must contain at least one lowercase letter.'
        isValid = false
      } else if (!/[0-9]/.test(password)) {
        this.errors.authPassword = 'Auth Password must contain at least one digit.'
        isValid = false
      } else if (!/[!@#$%^&*(),.?":{}|<>]/.test(password)) {
        this.errors.authPassword = 'Auth Password must contain at least one special character.'
        isValid = false
      }
      return isValid
    },
    validateEncryptionPassword(password) {
      let isValid = true
      if (password.length < 6) {
        this.errors.encryptionPassword = 'Encryption Password must be at least 6 characters.'
        isValid = false
      } else if (!/[A-Z]/.test(password)) {
        this.errors.encryptionPassword = 'Encryption Password must contain at least one uppercase letter.'
        isValid = false
      } else if (!/[a-z]/.test(password)) {
        this.errors.encryptionPassword = 'Encryption Password must contain at least one lowercase letter.'
        isValid = false
      } else if (!/[0-9]/.test(password)) {
        this.errors.encryptionPassword = 'Encryption Password must contain at least one digit.'
        isValid = false
      } else if (!/[!@#$%^&*(),.?":{}|<>]/.test(password)) {
        this.errors.encryptionPassword = 'Encryption Password must contain at least one special character.'
        isValid = false
      }
      return isValid
    },
  },
}
</script>

<template>
  <Teleport to="#elePageTitle">
    {{ pagetitle }}
  </Teleport>
  <div class="row">
    <div class="col-xl-6">
      <div class="card">
        <div class="card-header d-flex align-items-center">
          <h4 class="card-title">{{ $route.params.id ? 'Edit Credential' : 'Add New Credential' }}</h4>
        </div>
        <div class="card-body">
          <form @submit.prevent="saveCredential()">
            <div class="row">
              <div class="col-md-6 mb-3">
                <label for="name-input" class="form-label">Profile Name</label>
                <input type="text" class="form-control" placeholder="Enter name" id="name-input" v-model="credential.profileName" />
                <div v-if="errors.profileName" class="invalid-feedback">{{ errors.profileName }}</div>
              </div>
              <div class="col-md-6 mb-3">
                <label for="protocolType-input" class="form-label">Protocol Type</label>
                <template v-if="$route.params.id">
                  <div class="w-100" title="Protocol Type cannot be changed">
                    <input
                      id="protocolType-input"
                      type="text"
                      class="form-control"
                      :value="credential.protocolType === 'collectd' ? 'EZELINK' : credential.protocolType === 'snmp' ? 'SNMP' : credential.protocolType"
                      disabled
                    />
                  </div>
                </template>
                <select v-else id="protocolType-input" class="form-select" v-model="credential.protocolType">
                  <option value="collectd">EZELINK</option>
                  <option value="snmp">SNMP</option>
                </select>
                <div v-if="errors.protocolType" class="invalid-feedback">{{ errors.protocolType }}</div>
              </div>
              <template v-if="credential.protocolType === 'collectd'">
                <div class="col-md-6 mb-3">
                  <label for="username-input" class="form-label">Username</label>
                  <input type="text" class="form-control" placeholder="Enter username" id="username-input" autocomplete="new-password" v-model="credential.username" />
                  <div v-if="errors.username" class="invalid-feedback">{{ errors.username }}</div>
                </div>
                <div class="col-md-6 mb-3">
                  <label for="password-input" class="form-label">Password</label>
                  <input type="password" class="form-control" placeholder="Enter password" id="password-input" autocomplete="new-password" v-model="credential.password" />
                  <div v-if="errors.password" class="invalid-feedback">{{ errors.password }}</div>
                </div>
              </template>
              <template v-else-if="credential.protocolType === 'snmp'">
                <div class="col-md-6 mb-3">
                  <label for="snmpVersion-input" class="form-label">SNMP Version</label>
                  <template v-if="$route.params.id">
                    <div class="w-100" title="SNMP Version cannot be changed">
                      <input id="snmpVersion-input" type="text" class="form-control" :value="credential.snmpVersion === 'v1v2' ? 'V1 / V2' : credential.snmpVersion === 'v3' ? 'V3' : credential.snmpVersion" disabled />
                    </div>
                  </template>
                  <select v-else id="snmpVersion-input" class="form-select" v-model="credential.snmpVersion">
                    <option value="v1v2">V1 / V2</option>
                    <option value="v3">V3</option>
                  </select>
                  <div v-if="errors.snmpVersion" class="invalid-feedback">{{ errors.snmpVersion }}</div>
                </div>
                <template v-if="credential.snmpVersion === 'v1v2'">
                  <div class="col-md-6 mb-3">
                    <label for="readCommunity-input" class="form-label">Read Community</label>
                    <input type="text" class="form-control" placeholder="Enter read community" id="readCommunity-input" v-model="credential.readCommunity" />
                    <div v-if="errors.readCommunity" class="invalid-feedback">{{ errors.readCommunity }}</div>
                  </div>
                  <div class="col-md-6 mb-3">
                    <label for="writeCommunity-input" class="form-label">Write Community (Optional)</label>
                    <input type="text" class="form-control" placeholder="Enter write community" id="writeCommunity-input" v-model="credential.writeCommunity" />
                    <div v-if="errors.writeCommunity" class="invalid-feedback">{{ errors.writeCommunity }}</div>
                  </div>
                </template>
                <div class="col-md-6 mb-3">
                  <label for="description-input" class="form-label">Description</label>
                  <input type="text" class="form-control" placeholder="Enter description" id="description-input" v-model="credential.description" />
                  <div v-if="errors.description" class="invalid-feedback">{{ errors.description }}</div>
                </div>
                <template v-if="credential.snmpVersion === 'v3'">
                  <div class="col-md-6 mb-3">
                    <label for="username-input" class="form-label">Username</label>
                    <input type="text" class="form-control" placeholder="Enter username" id="username-input" autocomplete="new-password" v-model="credential.username" />
                    <div v-if="errors.username" class="invalid-feedback">{{ errors.username }}</div>
                  </div>
                  <div class="col-md-6 mb-3">
                    <label for="password-input" class="form-label">Password</label>
                    <input type="password" class="form-control" placeholder="Enter password" id="password-input" autocomplete="new-password" v-model="credential.password" />
                    <div v-if="errors.password" class="invalid-feedback">{{ errors.password }}</div>
                  </div>
                  <div class="col-md-6 mb-3">
                    <label for="contextName-input" class="form-label">Context Name</label>
                    <input type="text" class="form-control" placeholder="Enter context name" id="contextName-input" v-model="credential.contextName" />
                    <div v-if="errors.contextName" class="invalid-feedback">{{ errors.contextName }}</div>
                  </div>
                  <div class="col-md-6 mb-3">
                    <label for="authMethod-input" class="form-label">Authentication Method</label>
                    <select id="authMethod-input" class="form-select" v-model="credential.authMethod">
                      <option value="MD5">MD5</option>
                      <option value="SHA">SHA</option>
                      <option value="SHA-256">SHA-256</option>
                      <option value="SHA-512">SHA-512</option>
                    </select>
                    <div v-if="errors.authMethod" class="invalid-feedback">{{ errors.authMethod }}</div>
                  </div>
                  <div class="col-md-6 mb-3">
                    <label for="authPassword-input" class="form-label">Authentication Password</label>
                    <input type="password" class="form-control" placeholder="Enter authentication password" id="authPassword-input" autocomplete="new-password" v-model="credential.authPassword" />
                    <div v-if="errors.authPassword" class="invalid-feedback">{{ errors.authPassword }}</div>
                  </div>
                  <div class="col-md-6 mb-3">
                    <label for="encryptionMethod-input" class="form-label">Encryption Method</label>
                    <select id="encryptionMethod-input" class="form-select" v-model="credential.encryptionMethod">
                      <option value="DES">DES</option>
                      <option value="AES-128">AES-128</option>
                      <option value="AES-192">AES-192</option>
                      <option value="AES-256">AES-256</option>
                    </select>
                    <div v-if="errors.encryptionMethod" class="invalid-feedback">{{ errors.encryptionMethod }}</div>
                  </div>
                  <div class="col-md-6 mb-3">
                    <label for="encryptionPassword-input" class="form-label">Encryption Password</label>
                    <input
                      type="password"
                      class="form-control"
                      placeholder="Enter encryption password"
                      id="encryptionPassword-input"
                      autocomplete="new-password"
                      v-model="credential.encryptionPassword"
                    />
                    <div v-if="errors.encryptionPassword" class="invalid-feedback">{{ errors.encryptionPassword }}</div>
                  </div>
                </template>
                <div class="col-md-6 mb-3">
                  <label for="snmpPort-input" class="form-label">SNMP Port</label>
                  <input type="number" class="form-control" id="snmpPort-input" v-model="credential.snmpPort" oninput="this.value = this.value.replace(/[^0-9]/g, '')" min="0" />
                  <div v-if="errors.snmpPort" class="invalid-feedback">{{ errors.snmpPort }}</div>
                </div>
                <div class="col-md-6 mb-3 mb-md-0">
                  <label for="snmpTimeout-input" class="form-label">SNMP Timeout</label>
                  <input type="number" class="form-control" id="snmpTimeout-input" v-model="credential.timeout" oninput="this.value = this.value.replace(/[^0-9]/g, '')" min="0" />
                  <div v-if="errors.timeout" class="invalid-feedback">{{ errors.timeout }}</div>
                </div>
                <div class="col-md-6">
                  <label for="snmpRetries-input" class="form-label">SNMP Retries</label>
                  <input type="number" class="form-control" id="snmpRetries-input" v-model="credential.retries" oninput="this.value = this.value.replace(/[^0-9]/g, '')" min="0" />
                  <div v-if="errors.retries" class="invalid-feedback">{{ errors.retries }}</div>
                </div>
              </template>
            </div>
          </form>
        </div>
        <div class="card-footer">
          <div class="row">
            <div class="col-7">
              <router-link to="/credentials" class="btn btn-light d-inline-flex align-items-center">
                <i class="bx bx-arrow-back font-size-16 me-1"></i>
                Back to List
              </router-link>
            </div>
            <div class="col-5 d-flex justify-content-end">
              <button class="btn btn-success d-flex align-items-center" @click.prevent="saveCredential()" :disabled="saveBtnDisabled">
                <i v-if="!saveBtnDisabled" class="bx bx-check-double font-size-16"></i>
                <i v-else class="bx bx-loader bx-spin font-size-16"></i>
                <span class="ms-1">Save</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- end card -->
    </div>
  </div>
</template>
